import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Formik, Field, getIn } from 'formik';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

// UTILITY
import setYupValidationSchema from '@/utility/validationSchema/validationSchema';

// STYLES
import { Wrapper, Container, FormStyled } from './styles';

const initialFormData = {
  email: '',
};

const NotifyMe = props => {
  const { title, subtitle, loading, subscribed, onSubmit } = props;

  const [t] = useTranslation();
  const { user, isAuth } = useSelector(({ auth }) => ({
    user: auth.user,
    isAuth: auth.isAuth,
  }));

  function handleSubmit(values) {
    onSubmit(values.email);
  }

  return (
    <Wrapper className="section-wrapper notify-me-section">
      <div className="page-content">
        <Container>
          {title && (
            <Typography className="m-b-10" variant="h4">
              {title}
            </Typography>
          )}
          {subtitle && <Typography variant="subtitle2">{subtitle}</Typography>}
          <Formik
            initialValues={initialFormData}
            validationSchema={setYupValidationSchema('emailSchema', t)}
            onSubmit={handleSubmit}
          >
            {({ values, isValid, setFieldValue }) => {
              if (isAuth && user && user.email !== values.email) {
                setFieldValue('email', user.email);
              }

              return (
                <FormStyled>
                  <div className="notify-me-section__form">
                    {!isAuth && (
                      <Field name="email">
                        {({ form, field }) => {
                          const error = getIn(form.errors, field.name);
                          const touch = getIn(form.touched, field.name);

                          return (
                            <TextField
                              {...field}
                              fullWidth
                              placeholder={t('inputs.yourMailPlaceholder')}
                              error={touch && !!error}
                              helperText={touch && error}
                              disabled={loading}
                            />
                          );
                        }}
                      </Field>
                    )}
                    <Button
                      type="submit"
                      color="primary"
                      disabled={!isValid || loading}
                      className="notify-me-section__button"
                    >
                      {subscribed ? t('buttons.unsubscribe') : t('buttons.notifyMe')}
                    </Button>
                  </div>
                </FormStyled>
              );
            }}
          </Formik>
        </Container>
      </div>
    </Wrapper>
  );
};

NotifyMe.defaultProps = {
  title: '',
  subtitle: '',
};

NotifyMe.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  subscribed: PropTypes.bool.isRequired,
};

export default React.memo(NotifyMe);
